import $ from "jquery";
import {GPContextItems} from "./gp-context-items.js";
import {GPProjectView} from "./gp-projectview.js";
import {GPMisc} from "./gp-misc.js";
import {writable} from "svelte/store";
import {mode} from "./gp.js";
import {GPTypeCustomTempStructure} from "./gp-typecustomtempstructure";

export const modeStore = writable('optionBrush');
export const sizeStore = writable('optionBrush2');
export const somethingDrawn = writable(false);

export let GPContextFixedCutter = {
    fixedCutterLayer: null, // On this we draw and also display cursor.
    fixedCutterCanvas: null,
    fixedCutterImage: null,
    brushMode: null,
    brushSize: null,
    brushSizes: {'optionBrush1': 15, 'optionBrush2': 30, 'optionBrush3': 50},
    fixedCutterCursor: null,
    fixedCutterCursorLastPos: null,
    fixedCutterContext: null, //js 2d drawing context
    storesInitiated: false,
    projectView: null,

    init: function (projectView) {
        GPContextFixedCutter.projectView  = projectView;

        if (!GPContextFixedCutter.storesInitiated) {
            modeStore.subscribe((s) => {GPContextFixedCutter.brushMode = s; GPContextFixedCutter.updatefixedCutterCursorMode()});
            sizeStore.subscribe((s) => {GPContextFixedCutter.brushSize = s; GPContextFixedCutter.updatefixedCutterCursorMode()});

            mode.subscribe((m) => {
                if (m === "FixedCutter" && !GPContextFixedCutter.fixedCutterLayer)
                    GPContextFixedCutter.activate();
                if (m !== "FixedCutter" && GPContextFixedCutter.fixedCutterLayer)
                    GPContextFixedCutter.deactivate()
            })
            GPContextFixedCutter.storesInitiated = true;
        }
    },

    activate: function(id) {
        $(document).off("keydown", GPContextFixedCutter.handleKeyboard).on("keydown", GPContextFixedCutter.handleKeyboard);

        GPContextFixedCutter.fixedCutterLayer = new Konva.Layer();
        GPContextFixedCutter.fixedCutterLayer.opacity(0.5);
        GPContextFixedCutter.projectView.stage.add(GPContextFixedCutter.fixedCutterLayer);
        GPContextFixedCutter.createFixedCutterImage();

        GPContextFixedCutter.fixedCutterCursor = new Konva.Circle({
            x: 100,
            y: 100,
            radius: 30,
            stroke: 'white',
            strokeWidth: 1
          }).visible(false);
        GPContextFixedCutter.fixedCutterLayer.add(GPContextFixedCutter.fixedCutterCursor);

        GPContextFixedCutter.fixedCutterLayer.on("mouseenter", GPContextFixedCutter.activateCursor);
        GPContextFixedCutter.fixedCutterLayer.on("mouseleave", GPContextFixedCutter.disablefixedCutterCursor);
        GPContextFixedCutter.fixedCutterLayer.on('mousemove',GPContextFixedCutter.movefixedCutterCursorHandler);

        GPContextFixedCutter.resetCutter();
        GPContextFixedCutter.setupfixedCutterCursor();
    },

    createFixedCutterImage: function() {
        GPContextFixedCutter.fixedCutterCanvas = document.createElement('canvas');
        GPContextFixedCutter.fixedCutterCanvas.width = GP.project.sizeX;
        GPContextFixedCutter.fixedCutterCanvas.height = GP.project.sizeY;
        GPContextFixedCutter.fixedCutterImage = new Konva.Image({
            x: 0,
            y: 0,
            id: "fixedCutter",
            image: this.fixedCutterCanvas
        });
        GPContextFixedCutter.fixedCutterLayer.add(GPContextFixedCutter.fixedCutterImage);

        GPContextFixedCutter.fixedCutterImage.width(GPProjectView.width);
        GPContextFixedCutter.fixedCutterImage.height(GPProjectView.height);
    },

    deactivate: function() {
        $(document).off("keydown", GPContextFixedCutter.handleKeyboard);
        GPContextFixedCutter.disablefixedCutterCursor();
        GPContextFixedCutter.fixedCutterLayer.destroy();
        GPContextFixedCutter.fixedCutterLayer = null;
    },

    onresize: function () {
        if (GPContextFixedCutter.fixedCutterImage) {
            GPContextFixedCutter.fixedCutterImage.width(GPProjectView.width);
            GPContextFixedCutter.fixedCutterImage.height(GPProjectView.height);
        }
        GPContextFixedCutter.updatefixedCutterCursorMode()
    },


    resetCutter: function () {
        var isPaint = false;

        // now we need to bind some events
        // we need to start drawing on mousedown
        // and stop drawing on mouseup
        GPContextFixedCutter.fixedCutterLayer.off('touchstart mousedown').on('touchstart mousedown', function (event) {
            isPaint = true;
            GPContextFixedCutter.fixedCutterCursorLastPos = GPProjectView.getPointerPosition(event);
        });

        GPContextFixedCutter.fixedCutterLayer.off('touchend mouseup').on('touchend mouseup', function () {
            isPaint = false;
        });

        //if we're incidentaly leave drawing area and return later - start line at
        //the new entry point
        function updateCursorPos(event) {
            GPContextFixedCutter.fixedCutterCursorLastPos = GPProjectView.getPointerPosition(event);
            if (event.evt.buttons !== 1) isPaint = false;
        }
        GPContextFixedCutter.fixedCutterLayer.off('mouseenter', updateCursorPos).on('mouseenter', updateCursorPos);

        // and core function - drawing
        function doCutFunc (event) {
            if (!isPaint)
                return;

            var lastLocalPos = {
                x: GPContextFixedCutter.fixedCutterCursorLastPos.x / GPProjectView.sceneScale,
                y: GPContextFixedCutter.fixedCutterCursorLastPos.y / GPProjectView.sceneScale
            };

            var pos = GPProjectView.getPointerPosition(event);

            var localPos = {
                x: pos.x / GPProjectView.sceneScale,
                y: pos.y / GPProjectView.sceneScale
            };

            GPContextFixedCutter.doCut(lastLocalPos, localPos);

            GPContextFixedCutter.fixedCutterCursorLastPos = pos;
        }
        GPContextFixedCutter.fixedCutterLayer.off('touchmove mousemove', doCutFunc).on('touchmove mousemove', doCutFunc);

        // Good. Now we need to get access to GPProjectView.fixedCutterContext element
        GPContextFixedCutter.fixedCutterContext = GPContextFixedCutter.fixedCutterImage.getImage().getContext('2d');
        GPContextFixedCutter.fixedCutterContext.lineJoin = "round";
        GPContextFixedCutter.fixedCutterContext.lineCap = "round";
        GPContextFixedCutter.fixedCutterContext.lineWidth = GPContextFixedCutter.brushSize * GP.project.sizeX / 1024;

        GPContextFixedCutter.fixedCutterContext.strokeStyle = "#c08080";

        GPContextFixedCutter.updatefixedCutterCursorMode();
    },

    doCut: function(from, to) {

        if (GPContextFixedCutter.brushMode === "optionBrush") {
            GPContextFixedCutter.fixedCutterContext.globalCompositeOperation = 'source-over';
            somethingDrawn.set(true);
        }
        if (GPContextFixedCutter.brushMode === "optionEraser") {
            GPContextFixedCutter.fixedCutterContext.globalCompositeOperation = 'destination-out';
        }

        GPContextFixedCutter.fixedCutterContext.beginPath();
        GPContextFixedCutter.fixedCutterContext.moveTo(from.x, from.y);
        GPContextFixedCutter.fixedCutterContext.lineTo(to.x, to.y);
        GPContextFixedCutter.fixedCutterContext.lineWidth = GPContextFixedCutter.brushSize * GP.project.sizeX / 1024;
        GPContextFixedCutter.fixedCutterContext.stroke();

        GPContextFixedCutter.fixedCutterLayer.draw();
    },

    movefixedCutterCursor: function(pos) {
        GPContextFixedCutter.fixedCutterCursor.setX(pos.x);
        GPContextFixedCutter.fixedCutterCursor.setY(pos.y);
    },

    movefixedCutterCursorHandler: function(e) {
        var pos = GPProjectView.getPointerPosition(e);
        GPContextFixedCutter.movefixedCutterCursor(pos);
    },

    updatefixedCutterCursorMode: function() {
        if (!GPContextFixedCutter.fixedCutterLayer) return;

        var size = GPContextFixedCutter.brushSizes[GPContextFixedCutter.brushSize];
        GPContextFixedCutter.fixedCutterCursor.setRadius(size/2 * GPProjectView.width / 1024);
        if (GPContextFixedCutter.fixedCutterContext) GPContextFixedCutter.fixedCutterContext.lineWidth = size * GP.project.sizeX / 1024;
    },

    setupfixedCutterCursor: function() {
        if (!GPContextFixedCutter.fixedCutterCursorLastPos)
            GPContextFixedCutter.fixedCutterCursorLastPos = {
                x: $('#GPProjectView').innerWidth() / 2,
                y: $('#GPProjectView').innerHeight() * 0.8
            };
        GPContextFixedCutter.updatefixedCutterCursorMode();
        GPContextFixedCutter.fixedCutterCursor.setZIndex(1);
        GPContextFixedCutter.movefixedCutterCursor(GPContextFixedCutter.fixedCutterCursorLastPos);
        GPContextFixedCutter.activateCursor();
    },

    disablefixedCutterCursor: function() {
        GPContextFixedCutter.fixedCutterCursor.visible(false);
    },

    activateCursor: function() {
        GPContextFixedCutter.fixedCutterCursor.visible(true);
    },

    cutOffCustomObject: function() {
        var can = document.createElement('canvas');

        can.width = GP.project.sizeX * GPProjectView.sceneScale;
        can.height = GP.project.sizeY * GPProjectView.sceneScale;
        var ctx = can.getContext('2d');

        ctx.drawImage(GPProjectView.backgroundLayer.toCanvas(), 0, 0);
        ctx.globalCompositeOperation = 'destination-in';
        GPContextFixedCutter.fixedCutterLayer.opacity(1);
        ctx.drawImage(GPContextFixedCutter.fixedCutterLayer.toCanvas(), 0, 0);
        GPContextFixedCutter.fixedCutterLayer.opacity(0.5);

        var bounds = GPMisc.getContentBounds(ctx,can.width, can.height);

        var cut = ctx.getImageData(bounds[0], bounds[1], bounds[2]-bounds[0], bounds[3]-bounds[1]);
        ctx.clearRect(0,0,can.width, can.height);
        can.width = bounds[2]-bounds[0];
        can.height = bounds[3]-bounds[1];
        ctx.putImageData(cut, 0, 0);

        var scan = document.createElement('canvas');
        var sctx = scan.getContext('2d');
        scan.width = can.width / GPProjectView.sceneScale;
        scan.height = can.height / GPProjectView.sceneScale;
        sctx.drawImage(can, 0, 0, scan.width, scan.height);

        var data = scan.toDataURL('image/webp');

        //add custom object
        let nextFreeCustomTypeId = 0;
        GP.customObjects.forEach(c => {if (c.id >= nextFreeCustomTypeId) nextFreeCustomTypeId = c.id +1});
        let ct = {
            id: nextFreeCustomTypeId,
            type: "webp",
            "imgWidth": scan.width,
            "imgHeight": scan.height,
            "imgData": data
        };
        let ctt = new GPTypeCustomTempStructure(ct);

        GP.customObjects.push(ctt);
        GP.customObjectsById[ctt.id] = ctt;

        GP.saveUndo("items");
        var instance = GP.project.addCustom(nextFreeCustomTypeId, bounds[0] / GPProjectView.sceneScale, bounds[3] / GPProjectView.sceneScale, 1, 1, true, undefined, true );

        GPContextItems.addItemInstanceToView(instance);

        //clear working area
        GPContextFixedCutter.fixedCutterContext.clearRect(0,0,GP.project.sizeX, GP.project.sizeY);
        somethingDrawn.set(false);
    },

    handleKeyboard: function (e) {
        //Further actions only when project area active and applying textures
        if (($(".GPProjectView.active").length)) {
            var lastPos = {
                x: GPContextFixedCutter.fixedCutterCursorLastPos.x / GPProjectView.sceneScale,
                y: GPContextFixedCutter.fixedCutterCursorLastPos.y / GPProjectView.sceneScale
            };
            switch (e.which) {
                case 37: // left
                    GPContextFixedCutter.fixedCutterCursorLastPos.x -= 5;
                    break;

                case 38: // up
                    GPContextFixedCutter.fixedCutterCursorLastPos.y -= 5;
                    break;

                case 39: // right
                    GPContextFixedCutter.fixedCutterCursorLastPos.x += 5;
                    break;

                case 40: // down
                    GPContextFixedCutter.fixedCutterCursorLastPos.y += 5;
                    break;

                case 27: // esc
                    GP.restoreFocus();
                    break;

                default:
                    return; // exit this handler for other keys

                    e.preventDefault(); // prevent the default action (scroll / move caret)
            }
            var newPos = {
                x: GPContextFixedCutter.fixedCutterCursorLastPos.x / GPProjectView.sceneScale,
                y: GPContextFixedCutter.fixedCutterCursorLastPos.y / GPProjectView.sceneScale
            };
            GPContextFixedCutter.movefixedCutterCursor(GPContextFixedCutter.fixedCutterCursorLastPos);
            if (e.shiftKey) GPContextFixedCutter.doCut(lastPos, newPos);
        }
    }

};

